var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYouare4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_96_365)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1271 0L15.9386 0.258065C21.7454 1.42147 26.0962 6.33316 26.6253 12.2263C26.6464 12.459 26.5576 13.2247 26.7015 13.3221C32.9696 13.3305 38.5309 17.8995 39.7329 24.0423L39.991 25.853C39.9657 26.3691 40.0249 26.8979 39.991 27.4141C39.4366 36.0275 30.9423 41.9968 22.6045 39.3696C17.149 37.652 13.3357 32.44 13.3145 26.7076C13.2172 26.5637 12.4511 26.6526 12.2183 26.6314C3.72822 25.8741 -1.89235 17.5822 0.592044 9.39186C2.19611 4.09942 7.07178 0.355368 12.5654 0H14.1271ZM24.9789 13.4236C25.0127 7.12004 20.0947 1.92914 13.7801 1.71761C2.64051 1.34109 -2.70073 15.2597 5.88672 22.3416C7.93095 24.0296 10.7751 25.0703 13.433 24.9561C13.8139 22.0836 15.1387 19.3591 17.1744 17.3072C14.1652 14.6843 9.56041 15.7885 7.91825 19.3675C7.50771 19.1264 6.97444 19.0079 6.56813 18.7753C6.34805 18.6441 6.66124 18.1957 6.76705 18.0011C9.10755 13.7705 14.8932 12.9667 18.4484 16.1692C20.3402 14.697 22.6045 13.7747 24.9747 13.432L24.9789 13.4236ZM25.9862 15.0227C17.9659 15.4923 12.7643 23.78 15.9089 31.2216C19.5234 39.78 31.319 40.8165 36.4274 33.0365C41.5359 25.2565 35.4709 14.4685 25.9862 15.0185V15.0227Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9415 29.8428L33.5033 30.4689C32.7034 32.5334 30.6676 34.2172 28.5345 34.7587C24.9328 35.6767 21.2675 33.8533 19.7566 30.507L21.2591 29.8512C21.8474 30.8793 22.4526 31.7635 23.4726 32.4107C26.4818 34.3103 30.583 33.1595 31.9373 29.847L31.9415 29.8428Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9879 23.3572H23.388C22.9055 22.2107 21.2253 22.215 20.7301 23.3572H19.2445C19.071 23.1668 19.253 22.6761 19.3461 22.4434C20.3661 19.9516 24.9159 20.4762 24.9879 23.3572Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1298 23.357H32.4876C32.4876 23.357 32.4792 23.1666 32.4284 23.0693C32.0559 22.367 30.473 22.3459 30.0752 23.0185C30.0032 23.1412 30.0075 23.3612 29.9905 23.3612H28.3484C28.4542 20.0233 34.024 20.0275 34.1298 23.3612V23.357Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6263 10.0012H9.98414C9.98414 10.0012 9.95875 9.82772 9.89526 9.73888C9.37045 9.00276 8.15576 8.97738 7.60132 9.69234C7.51668 9.80234 7.49552 10.0012 7.48282 10.0012H5.84066C5.81527 8.56278 7.25004 7.54321 8.61286 7.49668C10.073 7.45014 11.6305 8.44855 11.6263 10.0012Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8485 10.0006H19.1302C19.1006 10.0006 19.1387 9.7045 18.8932 9.4972C18.2414 8.94723 16.8828 9.10799 16.5908 10.0006H14.991C15.2788 6.67964 20.5396 6.69233 20.8528 10.0006H20.8485Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_96_365"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouare4);
export default __webpack_public_path__ + "static/media/youare4.469b7d59bf014f990750c1e897ec6123.svg";
export { ForwardRef as ReactComponent };